module.exports = __webpack_public_path__ + "static/stripboard_screen@3x-510df3b67a05ca0839a701b7344dc8bc.png";